import styled from 'styled-components';

export const AppMessageContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    padding: 0 1rem;
`;

export const AppMessageText = styled.span<{ variant?: 'info' | 'warning' | 'error' | 'success' }>`
    margin-left: 0.5rem;
    font-size: 0.875rem;
    color: ${(props) => {
        switch (props.variant) {
            case 'info':
                return '#007bff';
            case 'warning':
                return '#ffc107';
            case 'error':
                return '#dc3545';
            case 'success':
                return '#28a745';
            default:
                return '#000';
        }
    }};
`;

export const AppMessageIcon = styled.span<{ variant?: 'info' | 'warning' | 'error' | 'success' }>`
    svg {
        width: 2rem;
        height: 2rem;
    }
    color: ${(props) => {
        switch (props.variant) {
            case 'info':
                return '#007bff';
            case 'warning':
                return '#ffc107';
            case 'error':
                return '#dc3545';
            case 'success':
                return '#28a745';
            default:
                return '#000';
        }
    }};
`;
